<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12.5 21C16.6926 21 20.2156 18.1332 21.2157 14.2529M12.5 21C8.30742 21 4.78442 18.1332 3.7843 14.2529M12.5 21C14.9853 21 17 16.9706 17 12C17 7.02944 14.9853 3 12.5 3M12.5 21C10.0147 21 8 16.9706 8 12C8 7.02944 10.0147 3 12.5 3M12.5 3C15.8652 3 18.799 4.84694 20.3431 7.58245M12.5 3C9.13481 3 6.20099 4.84694 4.65692 7.58245M20.3431 7.58245C18.2397 9.40039 15.4983 10.5 12.5 10.5C9.50172 10.5 6.76027 9.40039 4.65692 7.58245M20.3431 7.58245C21.0797 8.88743 21.5 10.3946 21.5 12C21.5 12.778 21.4013 13.5329 21.2157 14.2529M21.2157 14.2529C18.6334 15.6847 15.6619 16.5 12.5 16.5C9.3381 16.5 6.36662 15.6847 3.7843 14.2529M3.7843 14.2529C3.59871 13.5329 3.5 12.778 3.5 12C3.5 10.3946 3.92032 8.88743 4.65692 7.58245"
				:stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
		</svg>

	</div>
</template>

<script>
export default {
	name: 'IconSvgGlobe',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>